export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',
  separadorItens: '',

  //Específicos
  produtoDAF: 'Produto Farmacêutico',
  contrato: 'Contrato',
  nObjeto: 'Nº Objeto',
  parcela: 'Parcela',
  fatorEmbalagem: 'Fator Embalagem',
  valorUnitario: 'Valor Unitário R$',
  valorTotal: 'Valor Total R$',
  qtdTotal: 'Qtd Total',
};

export const headersObjetosContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Nº Objeto', width: 10, key: 'objetoNumero' },
  { text: 'Fator Emb', width: 12, key: 'objetoFatorEmbalagem' },
  { text: 'Produto', width: 65, key: 'objetoProdutoDaf' },
  { text: 'Valor Unitário R$', width: 10, key: 'objetoValorUnitario' },
  // { text: 'Qtd Registrada', width: 10, key: 'objetoQtdRegistrada' },
  // { text: 'V. Homologado R$', width: 10, key: 'objetoValorHomologado' },
  // { text: 'V. Reequilibrio R$', width: 10, key: 'objetoValorReequilibrio' },
  // { text: 'Valor Total R$', width: 10, key: 'objetoValorTotal' },
];

export const fieldObjectContratos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
